






import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Clickbutton extends Vue
{
	@Prop() label!: string;
	@Prop() labelDisabled!: string;
	@Prop() disabled!: boolean;

	@Watch("disabled")
	ondisabledChanged(val: boolean)
	{
		(this as any).model.disabled = val;
	}

	data()
	{
		return {
			model: {
				disabled: false
			}
		}
	}

	click(e: Event)
	{
		this.$emit("click", e);
	}
}
